export default "__VITE_ASSET__b3dBevjy__"